/* 网页http://weather.cma.cn/，扒的get 请求
 http://weather.cma.cn/api/weather/view?stationid=，获取天气
 */
 <template>
  <div id="weather-card">
    <div class="weather-card-details">
      <span>{{ option.name }}天气:</span>
      <span>{{ option.dayText }}</span>
      <span>{{ option.temperature }}</span>
      <img class="day-icon" :src="option.dayIcon" />
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "WeatherCard",
  data() {
    return {
      option: {},
      defaultData: {
        location: {
          id: "57494",
          name: "武汉",
          path: "中国, 湖北, 武汉",
          longitude: 114.13,
          latitude: 30.62,
          timezone: 8
        },
        daily: [
          {
            date: "2023/06/28",
            high: 34.0,
            dayText: "多云",
            dayCode: 1,
            dayWindDirection: "南风",
            dayWindScale: "3~4级",
            low: 29.0,
            nightText: "晴",
            nightCode: 0,
            nightWindDirection: "无持续风向",
            nightWindScale: "微风"
          },
          {
            date: "2023/06/29",
            high: 33.0,
            dayText: "中雨",
            dayCode: 8,
            dayWindDirection: "西南风",
            dayWindScale: "微风",
            low: 25.0,
            nightText: "暴雨",
            nightCode: 10,
            nightWindDirection: "西南风",
            nightWindScale: "3~4级"
          },
          {
            date: "2023/06/30",
            high: 32.0,
            dayText: "中雨",
            dayCode: 8,
            dayWindDirection: "西南风",
            dayWindScale: "微风",
            low: 26.0,
            nightText: "多云",
            nightCode: 1,
            nightWindDirection: "西南风",
            nightWindScale: "微风"
          },
          {
            date: "2023/07/01",
            high: 32.0,
            dayText: "小雨",
            dayCode: 7,
            dayWindDirection: "西南风",
            dayWindScale: "微风",
            low: 27.0,
            nightText: "小雨",
            nightCode: 7,
            nightWindDirection: "东北风",
            nightWindScale: "微风"
          },
          {
            date: "2023/07/02",
            high: 34.0,
            dayText: "阴",
            dayCode: 2,
            dayWindDirection: "西南风",
            dayWindScale: "微风",
            low: 29.0,
            nightText: "阴",
            nightCode: 2,
            nightWindDirection: "西南风",
            nightWindScale: "微风"
          },
          {
            date: "2023/07/03",
            high: 35.0,
            dayText: "阴",
            dayCode: 2,
            dayWindDirection: "西南风",
            dayWindScale: "微风",
            low: 29.0,
            nightText: "小雨",
            nightCode: 7,
            nightWindDirection: "西南风",
            nightWindScale: "3~4级"
          },
          {
            date: "2023/07/04",
            high: 30.0,
            dayText: "大雨",
            dayCode: 9,
            dayWindDirection: "西南风",
            dayWindScale: "微风",
            low: 24.0,
            nightText: "大雨",
            nightCode: 9,
            nightWindDirection: "西南风",
            nightWindScale: "微风"
          }
        ],
        now: {
          precipitation: 0.0,
          temperature: 33.9,
          pressure: 1001.0,
          humidity: 51.0,
          windDirection: "西南风",
          windDirectionDegree: 209.0,
          windSpeed: 6.2,
          windScale: "4级"
        },
        alarm: [],
        lastUpdate: "2023/06/28 14:40"
      }
    };
  },
  methods: {
    getWeather() {
      const _this = this;
      let initData = null;
      axios({
        url: "http://weather.cma.cn/api/weather/view",
        method: "get"
      })
        .then(function(response) {
          if (
            response.status === 200 &&
            response.data &&
            response.data.code === 0
          ) {
            initData = response.data.data;
          }
          // handle success
          // console.log(response, "initData", initData);
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        })
        .finally(function() {
          // always executed
          // console.log("finally", initData);
          _this.setOptionData(initData ? initData : _this.defaultData);
        });
    },
    setOptionData(data) {
      const { location, daily } = data;
      const { date, dayText, low, high, dayCode } = daily[0];
      this.option = {
        date: date,
        dayText: dayText,
        temperature: high + "℃/" + low + "℃",
        dayIcon: `http://weather.cma.cn/static/img/w/icon/w${dayCode}.png`,
        name: location.name
      };
    }
  },
  mounted() {
    const { getWeather } = this;

    getWeather();
  }
};
</script>

<style lang="less">
#weather-card {
  height: 50px;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  padding-right: 20px;

  .weather-card-details {
    height: 50px;
    font-weight: bold;
    text-indent: 20px;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .day-icon {
    height: 50px;
    margin-left: 10px;
  }
}
</style>
